export default __webpack_public_path__ + "f41f2ffc372918206e72b6fa47d094ef.svg";